import React from 'react';
const colors = ['#243f86', '#9b89d9', '#d87d35', '#4e8965', '#388899', '#bc6487'];
const money = value => value === null ? 'Unavailable' : new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', maximumFractionDigits: 0,
}).format(value);

export function BudgetBreakdown({ title, rows, total }) {
  return <section className="rounded-lg border border-gray-200 bg-white p-5 sm:p-6">
    <h4 className="text-xl font-bold text-slate-950">{title}</h4>
    <div className="my-5 flex h-5 overflow-hidden rounded-full bg-slate-100" aria-hidden="true">
      {rows.map((row, i) => row.value > 0 && <span key={row.id} style={{ backgroundColor: colors[i], width: `${row.value / total * 100}%` }} />)}
    </div>
    <ul className="space-y-4">
      {rows.map((row, i) => <li key={row.id} className="flex items-start justify-between gap-4 text-sm">
        <span className="flex items-center gap-2 text-slate-700"><span className="h-3 w-3 shrink-0 rounded-full" style={{ backgroundColor: colors[i] }} />{row.label}</span>
        <span className="text-right font-semibold tabular-nums text-slate-900">{money(row.value)}<span className="ml-2 inline-block text-xs font-normal text-slate-500">{total > 0 ? `${(row.value / total * 100).toFixed(1)}%` : '—'}</span></span>
      </li>)}
    </ul>
  </section>;
}

